
    <ng-container
      *ngIf="
        location.controllers.$values
          | getControllerByIndex : controllerIndex as controllerAtIndex
      "
    >
      <ng-container
        *ngIf="
          controllerAtIndex
            | findPropertyByCode
              : codeFrom
              : codeTo
              : updated as setTemperatureProperties
        "
      >
        <ng-container
          *ngIf="
            controllerAtIndex
              | getRoomTemperatureData
                : modeRoomOrBathroom
                : updated as tempData
          "
        >
        <div
        [title]="setTemperatureProperties[0]?.name | translate"
        [ngClass]="[
          displaySize === 'minimal' ? 'status-container-minimal' : ''
        ]"
        class="full-height flex-row"
        >
        <div
        class="icon-background-off black"
        [ngStyle]="displaySize !== 'minimal' ? { 'margin-left': 'inherit' } : {}"
        [ngClass]="[activeIcon]"
      ></div>
          <div class="status-text-on status-text-ellipsis">
            <!-- IF ROOM IS OCCUPIED OR HVAC MODE IS NOT IN AUTO MODE DISPLAY BASIC SET TEMP VALUE -->
            @if (((controllerAtIndex | findProperty: Property.isContactor: updated) | propIsActive) ||
            !((controllerAtIndex | findProperty : Property.isHvacHeatCoolAuto: updated) | propIsActive )) {
            {{ setTemperatureProperties[0]?.value }}
            }
            <!-- ROOM RENTED -->
            @else if (location.isRented  && tempData.baseSetProp?.value != null && tempData.baseSetProp?.value !== ''
            && tempData.ecoHyst1Prop?.value != null && tempData.ecoHyst1Prop?.value !== '') {
              <span class="font-size10"> {{ (++tempData.baseSetProp?.value) - (++tempData.ecoHyst1Prop?.value) }}
            -
                {{ (++tempData.baseSetProp?.value) + (++tempData.ecoHyst1Prop?.value) }}</span>
            }
            <!-- ROOM NOT RENTED -->
            @else if (!location.isRented  && tempData.baseSetProp?.value != null && tempData.baseSetProp?.value !== ''
            && tempData.ecoHyst1Prop?.value != null && tempData.ecoHyst1Prop?.value !== ''
             && tempData.ecoHyst2Prop?.value != null && tempData.ecoHyst2Prop?.value !== ''
            ) {
              <span class="font-size10"> {{ (++tempData.baseSetProp?.value) - (++tempData.ecoHyst1Prop?.value) - (++tempData.ecoHyst2Prop?.value) }}
            -
              {{ (++tempData.baseSetProp?.value) + (++tempData.ecoHyst1Prop?.value) + (++tempData.ecoHyst2Prop?.value) }}</span>
            }
            <ng-container *ngIf="displaySize !== 'minimal'">
            {{ sufix +" "+(setTemperatureProperties[0]?.name | translate)  }}
          </ng-container>
          </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
